<button class="button button--secondary" (click)="openIncidentDialog($event)">
  {{ "Services.Fulfilment.ReportProblem" | translate }}
</button>
